import type { BafaPhase } from "./state";

interface Props {
  phase: BafaPhase;
  step: 1 | 2 | 3 | 4;
  maxReachedStep: 1 | 2 | 3 | 4;
  onJumpToImport: () => void;
  onJumpToStep: (n: 1 | 2 | 3 | 4) => void;
}

interface DotSpec {
  key: string;
  label: number;
  ariaLabel: string;
  current: boolean;
  unlocked: boolean;
  onClick: () => void;
}

export function StepIndicator({ phase, step, maxReachedStep, onJumpToImport, onJumpToStep }: Props) {
  const dots: DotSpec[] = [
    {
      key: "import",
      label: 1,
      ariaLabel: "Schritt 1: Daten importieren",
      current: phase === "import",
      unlocked: true,
      onClick: onJumpToImport,
    },
    ...([1, 2, 3, 4] as const).map<DotSpec>((n) => ({
      key: `wizard-${n}`,
      label: n + 1,
      ariaLabel: `Schritt ${n + 1}`,
      current: phase === "wizard" && n === step,
      unlocked: n <= maxReachedStep,
      onClick: () => onJumpToStep(n),
    })),
  ];

  return (
    <nav className="step-indicator" aria-label="Fortschritt">
      {dots.map((d, i) => (
        <span key={d.key} style={{ display: "inline-flex", alignItems: "center" }}>
          <button
            type="button"
            className={[
              "step-dot",
              d.unlocked ? "active" : "",
              d.current ? "current" : "",
              !d.unlocked ? "locked" : "",
            ].filter(Boolean).join(" ")}
            disabled={!d.unlocked}
            aria-current={d.current ? "step" : undefined}
            aria-label={d.ariaLabel}
            onClick={() => d.unlocked && d.onClick()}
          >
            {d.label}
          </button>
          {i < dots.length - 1 && <span className="step-line" />}
        </span>
      ))}
    </nav>
  );
}
